import { UserAccountInfo } from 'types/User';
import { createClient } from '../clientConfiguration';

const apiClient = createClient({
  baseURL: '/rest-api/v1',
});

const Account = {
  apiClient,
  async getClusterId() {
    const response = await apiClient.get<UserAccountInfo>(
      '/v1/account/summary/current',
    );

    return response?.data?.clusterId;
  },
};

export { Account };
